<template>
  <router-view />
</template>

<script setup>
import { onMounted } from 'vue';

import { useUserStore } from './store/user';

const userStore = useUserStore();

onMounted(() => {
  if (!userStore.token) return;

  userStore.refreshProfile().catch(() => {});
});
</script>
